<template>
  <div class="DataUpdate">
    <modal
      name="UpdateModal"
      width="900"
      height="auto"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
    >
    <div class="modalContainer dataUpdateModal">
      <div class="tabs">
        <a
          @click="activetab = 1"
          :class="{ active: activetab === 1 }"
        >
          Datos Básicos
        </a>
      </div>
    <div class="modalBody">
      <div v-if="activetab === 1" class="tabcontent">
        <ValidationObserver ref="obsFieldsUpdate">
        <FormUpdateClient
          :FieldsForm="formUpdate"
          :ModelForm="formUpdModel"
          :method="executeProcess"
          v-if="renderComponent2"
        />
        </ValidationObserver>
      </div>
    </div>
        <div class="modalActions">
          <button
            id="UpdateUser"
            @click="UpdateUser"
            class="loginbtn primaryBtn"
          >
          Actualizar
          </button>

          <button
            id="CancelUser"
            @click="CancelUser"
            class="loginbtn secondaryBtn"
          >
          Cancelar
          </button>
        </div>
      </div>
    </modal>
    <div class="titlePage">ACTUALIZACION DE DATOS</div>
    <va-notification color="info" v-if="addRExito" class="refNoData"
      >Se actualizo correctamente el usuario solicitado.</va-notification
    >
    <va-notification color="danger" v-if="refNoUpdate" class="refNoData"
      >La actualizacion del usuario presento un fallo.</va-notification
    >
    <va-notification color="danger" v-if="refWSUpdate" class="refNoData"
      >El servicio que ejecuta la actualización no se encuentra
      activo.</va-notification
    >

    <ValidationObserver ref="obsFieldsSearch">
      <FormSearchClient
        :FieldsForm="formSearch"
        :ModelForm="formSchModel"
        :method="executeProcess"
      />
    </ValidationObserver>
    <va-notification color="danger" id="refNoData" class="refNoData noShow"
      >No se encontró información del usuario solicitado.</va-notification
    >
    <div class="listClients">
      <DataTablePersons
        :InfoView="this.DLPersons"
        :HeadTable="this.HDPersons"
        :method="processData"
        v-if="renderComponent1"
      />
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-duplicates
import FormSearchClient from '@/components/forms/Forms.vue'
// eslint-disable-next-line import/no-duplicates
import FormUpdateClient from '@/components/forms/Forms.vue'
import IberoHelpers from '@/store/helpers.js'
import DataTablePersons from '@/components/data-tables/DataPersonsUpdate.vue'
import DataTransfer from '@/components/data-tables/DataTransfer.vue'
import FormAddress from '@/components/Forms.vue'

export default {
  name: 'DataUpdate',
  components: {
    DataTablePersons,
    FormSearchClient,
    FormUpdateClient,
    DataTransfer,
    FormAddress,
  },
  data () {
    return {
      activetab: 1,
      formSchModel: {
        idTypeIdent: '',
        numIdentify: '',
        IdBannerNum: '',
      },
      formAddModel: {
        IdAddressList: '',
        IdAddressStreet: '',
        IdAddressNumTxt: '',
        IdAddressNum: '',
        IdAddressRefTxt: '',
        IdAddressRef: '',
        IdAddressExtra: '',
      },
      formAddress: [
        {
          id: 'IdAddressList',
          model: 'IdAddressList',
          type: 'Select2',
          values: this.$store.state.listAddress,
          placeholder: 'Dirección',
          validate: {
            required: true,
          },
          class: 'col-md-3',
        },
        {
          id: 'IdAddressStreet',
          model: 'IdAddressStreet',
          type: 'input',
          values: this.$store.state.listAddress,
          placeholder: 'Dirección',
          validate: {
            required: true,
            alpha_num: true,
            max: 4,
          },
          class: 'col-md-2',
        },
        {
          id: 'IdAddressNumTxt',
          model: 'IdAddressNumTxt',
          type: 'html',
          values: '#',
          class: 'col-md-1',
        },
        {
          id: 'IdAddressNum',
          model: 'IdAddressNum',
          type: 'input',
          values: '',
          placeholder: '#',
          validate: {
            required: true,
            alpha_num: true,
            max: 4,
          },
          class: 'col-md-2',
        },
        {
          id: 'IdAddressRefTxt',
          model: 'IdAddressRefTxt',
          type: 'html',
          values: '-',
          class: 'col-md-1',
        },
        {
          id: 'IdAddressRef',
          model: 'IdAddressRef',
          type: 'input',
          placeholder: '#',
          values: '',
          validate: {
            required: true,
            alpha_num: true,
            max: 4,
          },
          class: 'col-md-2',
        },
        {
          id: 'IdAddressExtra',
          model: 'IdAddressExtra',
          type: 'input',
          placeholder: 'Informacion adicional',
          values: '',
          validate: {
            max: 35,
          },
          class: 'col-md-11',
        },
      ],
      formSearch: [
        {
          id: 'Sch_Document',
          model: 'numIdentify',
          name: 'Documento de Identidad',
          type: 'input',
          placeholder: 'Documento de Identidad',
          values: '',
          validate: {
            required: false,
            min: 7,
            max: 15,
          },
          class: 'col-md-3',
        },
        {
          id: 'Sch_IdBanner',
          model: 'IdBannerNum',
          name: 'Id Banner',
          type: 'input',
          placeholder: 'Id Banner',
          values: '',
          validate: {
            required: false,
            numeric: true,
          },
          class: 'col-md-3',
        },
        {
          id: 'Sch_Button',
          type: 'button',
          placeholder: 'Consultar',
          class: 'col-md-3',
        },
      ],
      formUpdModel: {
        idUpdatedBy: this.$session.get('IberoJWTAdminLogin').idPerson,
        IdPerson: '',
        IdStatus: '',
        IdUsrName: '',
        IdDocType: '',
        IdDocTypeName: '',
        IdDocument: '',
        IdBanner: '',
        IdNombre: '',
        IdApellidos: '',
        IdAddress: '',
        IdMail: '',
        IdCelPhone: '',
        IdHomePhone: '',
        IdState: '',
        IdCity: '',
        IdBornDay: '',
        IdBornMon: '',
        IdBornYear: '',
        IdDateBirth: '',
        IdFileDoc: '',
        IdTermiCondi: '',
        IdNewsLetter: '',
        IdObservaciones: '',
        CodTransferCenter: [],
      },
      formUpdate: [
        {
          id: 'IdDocTypeName',
          model: 'IdDocTypeName',
          name: 'Tipo de identificación',
          type: 'informative',
          placeholder: 'Tipo de identificación',
          values: '',
          validate: {
            required: false,
          },
          class: 'col-md-3',
        },
        {
          id: 'IdDocument',
          model: 'IdDocument',
          name: 'Documento de Identidad',
          type: 'informative',
          placeholder: 'Documento de Identidad',
          values: '',
          validate: {
            required: false,
            max: 15,
          },
          class: 'col-md-3',
        },
        {
          id: 'IdBanner',
          model: 'IdBanner',
          name: 'Id Banner',
          type: 'informative',
          placeholder: 'Id Banner',
          values: '',
          validate: {
            required: false,
          },
          class: 'col-md-6',
        },
        {
          id: 'IdNombre',
          model: 'IdNombre',
          name: 'Nombres',
          type: 'input',
          placeholder: 'Nombres',
          values: '',
          validate: {
            required: true,
          },
          class: 'col-md-6',
        },
        {
          id: 'IdApellidos',
          model: 'IdApellidos',
          name: 'Apellidos',
          type: 'input',
          placeholder: 'Apellidos',
          values: '',
          validate: {
            required: true,
          },
          class: 'col-md-6',
        },
        {
          id: 'IdAddress',
          model: 'IdAddress',
          name: 'Dirección',
          type: 'inputkey',
          placeholder: 'Dirección',
          values: '',
          validate: {
            required: true,
          },
          class: 'col-md-6',
        },
        {
          id: 'IdMail',
          model: 'IdMail',
          name: 'Correo Electrónico Personal',
          type: 'input',
          placeholder: 'Correo Electrónico Personal',
          values: '',
          validate: {
            required: true,
            email: true,
          },
          class: 'col-md-6',
        },
        {
          id: 'IdCelPhone',
          model: 'IdCelPhone',
          name: 'Teléfono Celular',
          type: 'input',
          placeholder: 'Teléfono Celular',
          values: '',
          validate: {
            required: true,
            numeric: true,
            max: 10,
          },
          class: 'col-md-3',
        },
        {
          id: 'IdHomePhone',
          model: 'IdHomePhone',
          name: 'Teléfono Fijo',
          type: 'input',
          placeholder: 'Teléfono Fijo',
          values: '',
          validate: {
            required: false,
            numeric: true,
            max: 7,
          },
          class: 'col-md-3',
        },
        {
          id: 'IdState',
          model: 'IdState',
          name: 'Departamento',
          type: 'Select',
          placeholder: 'Departamento',
          class: 'col-md-3',
          values: this.$store.state.StateList,
          validate: {
            required: true,
          },
        },
        {
          id: 'IdCity',
          model: 'IdCity',
          name: 'Ciudad',
          type: 'Select',
          placeholder: 'Ciudad',
          validate: {
            required: true,
          },
          class: 'col-md-3',
          values: this.$store.state.CityList,
        },
        {
          id: 'IdBornDate',
          model: 'IdBornDate',
          name: 'Fecha de Nacimiento',
          type: 'informative',
          class: 'col-md-2',
        },
        {
          id: 'IdBornDay',
          model: 'IdBornDay',
          name: 'Día',
          type: 'Select',
          placeholder: 'Día',
          validate: {
            required: true,
          },
          class: 'col-md-2',
          values: [
            { id: '01', value: '1' },
            { id: '02', value: '2' },
            { id: '03', value: '3' },
            { id: '04', value: '4' },
            { id: '05', value: '5' },
            { id: '06', value: '6' },
            { id: '07', value: '7' },
            { id: '08', value: '8' },
            { id: '09', value: '9' },
            { id: '10', value: '10' },
            { id: '11', value: '11' },
            { id: '12', value: '12' },
            { id: '13', value: '13' },
            { id: '14', value: '14' },
            { id: '15', value: '15' },
            { id: '16', value: '16' },
            { id: '17', value: '17' },
            { id: '18', value: '18' },
            { id: '19', value: '19' },
            { id: '20', value: '20' },
            { id: '21', value: '21' },
            { id: '22', value: '22' },
            { id: '23', value: '23' },
            { id: '24', value: '24' },
            { id: '25', value: '25' },
            { id: '26', value: '26' },
            { id: '27', value: '27' },
            { id: '28', value: '28' },
            { id: '29', value: '29' },
            { id: '30', value: '30' },
            { id: '31', value: '31' },
          ],
        },
        {
          id: 'IdBornMon',
          model: 'IdBornMon',
          name: 'Mes',
          type: 'Select',
          placeholder: 'Mes',
          validate: {
            required: true,
          },
          class: 'col-md-2',
          values: [
            { id: '01', value: 'Enero' },
            { id: '02', value: 'Febrero' },
            { id: '03', value: 'Marzo' },
            { id: '04', value: 'Abril' },
            { id: '05', value: 'Mayo' },
            { id: '06', value: 'Junio' },
            { id: '07', value: 'Julio' },
            { id: '08', value: 'Agosto' },
            { id: '09', value: 'Septiembre' },
            { id: '10', value: 'Octubre' },
            { id: '11', value: 'Noviembre' },
            { id: '12', value: 'Diciembre' },
          ],
        },
        {
          id: 'IdBornYear',
          model: 'IdBornYear',
          name: 'Año',
          type: 'Select',
          placeholder: 'Año',
          validate: {
            required: true,
          },
          class: 'col-md-2',
          values: [
            { id: '2026', value: '2026' },
            { id: '2025', value: '2025' },
            { id: '2024', value: '2024' },
            { id: '2023', value: '2023' },
            { id: '2022', value: '2022' },
            { id: '2021', value: '2021' },
            { id: '2020', value: '2020' },
            { id: '2019', value: '2019' },
            { id: '2018', value: '2018' },
            { id: '2017', value: '2017' },
            { id: '2016', value: '2016' },
            { id: '2015', value: '2015' },
            { id: '2014', value: '2014' },
            { id: '2013', value: '2013' },
            { id: '2012', value: '2012' },
            { id: '2011', value: '2011' },
            { id: '2010', value: '2010' },
            { id: '2009', value: '2009' },
            { id: '2008', value: '2008' },
            { id: '2007', value: '2007' },
            { id: '2006', value: '2006' },
            { id: '2005', value: '2005' },
            { id: '2004', value: '2004' },
            { id: '2003', value: '2003' },
            { id: '2002', value: '2002' },
            { id: '2001', value: '2001' },
            { id: '2000', value: '2000' },
            { id: '1999', value: '1999' },
            { id: '1998', value: '1998' },
            { id: '1997', value: '1997' },
            { id: '1996', value: '1996' },
            { id: '1995', value: '1995' },
            { id: '1994', value: '1994' },
            { id: '1993', value: '1993' },
            { id: '1992', value: '1992' },
            { id: '1991', value: '1991' },
            { id: '1990', value: '1990' },
            { id: '1989', value: '1989' },
            { id: '1988', value: '1988' },
            { id: '1987', value: '1987' },
            { id: '1986', value: '1986' },
            { id: '1985', value: '1985' },
            { id: '1984', value: '1984' },
            { id: '1983', value: '1983' },
            { id: '1982', value: '1982' },
            { id: '1981', value: '1981' },
            { id: '1980', value: '1980' },
            { id: '1979', value: '1979' },
            { id: '1978', value: '1978' },
            { id: '1977', value: '1977' },
            { id: '1976', value: '1976' },
            { id: '1975', value: '1975' },
            { id: '1974', value: '1974' },
            { id: '1973', value: '1973' },
            { id: '1972', value: '1972' },
            { id: '1971', value: '1971' },
            { id: '1970', value: '1970' },
            { id: '1969', value: '1969' },
            { id: '1968', value: '1968' },
            { id: '1967', value: '1967' },
            { id: '1966', value: '1966' },
            { id: '1965', value: '1965' },
            { id: '1964', value: '1964' },
            { id: '1963', value: '1963' },
            { id: '1962', value: '1962' },
            { id: '1961', value: '1961' },
            { id: '1960', value: '1960' },
            { id: '1959', value: '1959' },
            { id: '1958', value: '1958' },
            { id: '1957', value: '1957' },
            { id: '1956', value: '1956' },
            { id: '1955', value: '1955' },
            { id: '1954', value: '1954' },
            { id: '1953', value: '1953' },
            { id: '1952', value: '1952' },
            { id: '1951', value: '1951' },
            { id: '1950', value: '1950' },
            { id: '1949', value: '1949' },
            { id: '1948', value: '1948' },
            { id: '1947', value: '1947' },
            { id: '1946', value: '1946' },
            { id: '1945', value: '1945' },
            { id: '1944', value: '1944' },
            { id: '1943', value: '1943' },
            { id: '1942', value: '1942' },
            { id: '1941', value: '1941' },
            { id: '1940', value: '1940' },
            { id: '1939', value: '1939' },
            { id: '1938', value: '1938' },
            { id: '1937', value: '1937' },
            { id: '1936', value: '1936' },
            { id: '1935', value: '1935' },
            { id: '1934', value: '1934' },
            { id: '1933', value: '1933' },
            { id: '1932', value: '1932' },
            { id: '1931', value: '1931' },
            { id: '1930', value: '1930' },
            { id: '1929', value: '1929' },
            { id: '1928', value: '1928' },
            { id: '1927', value: '1927' },
            { id: '1926', value: '1926' },
            { id: '1925', value: '1925' },
            { id: '1924', value: '1924' },
            { id: '1923', value: '1923' },
            { id: '1922', value: '1922' },
            { id: '1921', value: '1921' },
            { id: '1920', value: '1920' },
            { id: '1919', value: '1919' },
            { id: '1918', value: '1918' },
            { id: '1917', value: '1917' },
            { id: '1916', value: '1916' },
            { id: '1915', value: '1915' },
            { id: '1914', value: '1914' },
            { id: '1913', value: '1913' },
            { id: '1912', value: '1912' },
            { id: '1911', value: '1911' },
            { id: '1910', value: '1910' },
            { id: '1909', value: '1909' },
            { id: '1908', value: '1908' },
            { id: '1907', value: '1907' },
            { id: '1906', value: '1906' },
            { id: '1905', value: '1905' },
            { id: '1904', value: '1904' },
            { id: '1903', value: '1903' },
            { id: '1902', value: '1902' },
            { id: '1901', value: '1901' },
            { id: '1900', value: '1900' },
          ],
        },
        {
          id: 'IdObservaciones',
          model: 'IdObservaciones',
          name: 'Observaciones',
          type: 'textarea',
          placeholder: '',
          values: '',
          validate: {
            required: true,
          },
          class: 'col-md-12',
        },
        {
          id: 'IdNewsLetter',
          name: 'Informacion Comercial',
          model: 'IdNewsLetter',
          type: 'accepted',
          placeholder: 'Recibir informacion comercial',
          values: '',
          validate: {
            required: false,
          },
          class: 'col-md-6 linkref',
        },
      ],
      HDPersons: [
        {
          name: 'idBanner',
          title: 'Id Banner',
          width: '10%',
        },
        {
          name: 'nameDocument',
          title: 'Tipo Identificación',
          width: '20%',
        },
        {
          name: 'numDocument',
          title: 'Num Identificación',
          width: '20%',
        },
        {
          name: 'namPerson',
          title: 'Nombres',
          sortField: 'namPerson',
          width: '20%',
        },
        {
          name: 'lastNamePerson',
          title: 'Apellidos',
          sortField: 'lastNamePerson',
          width: '20%',
        },
        {
          name: '__slot:telefono',
          title: 'Celular',
          width: '10%',
        },
        {
          name: '__slot:status',
          title: 'Activo',
          dataClass: 'text-center',
          width: '10%',
        },
        {
          name: '__slot:actions',
          dataClass: 'text-right',
          actionRef: [
            {
              label: 'Editar',
              icon: 'fa-pencil',
              action: 'edit',
            },
          ],
        },
      ],
      HDTransfer: [
        {
          name: 'idPeriod',
          title: 'Programa',
          width: '20%',
        },
        {
          name: 'namOperator',
          title: 'Centro de Transferencia',
          width: '20%',
        },
        {
          name: 'desPeriod',
          title: 'Periodo',
          width: '10%',
        },
        {
          name: '__slot:sello',
          title: 'Sello F.',
          width: '10%',
        },
        {
          name: '__slot:editar',
          title: 'Editar',
          width: '30%',
        },
      ],
      DLPersons: [],
      SelectPerson: [],
      UpdateOperator: [],
      renderComponent1: false,
      renderComponent2: false,
      addRExito: false,
      refNoUpdate: false,
      refWSUpdate: false,
    }
  },
  methods: {
    UpdateUser () {
      this.limpiaref()
      if (this.activetab === 1) {
        return new Promise((resolve, reject) => {
          this.$refs.obsFieldsUpdate.validate().then(results => {
            if (!results) {
              resolve(false)
            } else {
              let loader = this.$loading.show()
              debugger

              var totalinf = IberoHelpers.sendFormUpdateIntranet(
                this.$store,
                this.formUpdModel
              )
              debugger
              totalinf.then(Response => {
                this.renderComponent1 = false
                if (Response === false) {
                  this.refWSUpdate = true
                  resolve(false)
                } else if (!(Response.status === 200)) {
                  this.refNoUpdate = true
                  resolve(false)
                } else {
                  this.addRExito = true
                  resolve(true)
                }
                this.$modal.hide('UpdateModal')
                this.searchForm()
                loader.hide()
              })
            }
          })
        })
      } else {
        let loader = this.$loading.show()
        var updateOperaPerson = IberoHelpers.sendFormUpdateOperator(
          this.$store,
          this.UpdateOperator
        )
        updateOperaPerson.then(Response => {
          this.renderComponent1 = false
          if (Response === false) {
            this.refWSUpdate = true
          } else if (!(Response.status === 200)) {
            this.refNoUpdate = true
          } else {
            this.addRExito = true
          }
          this.$modal.hide('UpdateModal')
          this.searchForm()
          loader.hide()
        })
      }
    },
    CancelUser () {
      this.limpiaref()
      this.$modal.hide('UpdateModal')
    },
    limpiaref () {
      this.addRExito = false
      this.refNoUpdate = false
      this.refWSUpdate = false
    },
    searchForm () {
      document.getElementById('refNoData').classList.add('noShow')
      let loader = this.$loading.show()
      var ListPersons = IberoHelpers.getPersonList(
        this.$store,
        this.formSchModel,
        1
      )
      this.renderComponent1 = false
      ListPersons.then(Response => {
        if (Response.data === undefined || Response.data === '') {
          document.getElementById('refNoData').classList.remove('noShow')
        } else {
          if (Array.isArray(Response.data)) {
            this.DLPersons = Response.data
          } else {
            this.DLPersons = [Response.data]
          }
          IberoHelpers.forceRerender1(this)
        }
        loader.hide()
      })
    },
    executeProcess: function (event, refer) {
      this.limpiaref()
      switch (event.target.id) {
        case 'EditOperator':
          refer.IdBanner = this.formUpdModel.IdBanner
          refer.actPeriod = event.periodo
          this.UpdateOperator.push(refer)
          break
        case 'IdState':
          this.formUpdModel.IdCity = ''
          IberoHelpers.getCitiesListByState(
            this.$store.state.ApiIbero.WSParametric,
            this.$store.state.CityList,
            event.target.value
          )
          break
        case 'btn_Sch_Button':
          return new Promise((resolve, reject) => {
            this.$refs.obsFieldsSearch.validate().then(results => {
              if (!results) {
                resolve(false)
              } else {
                this.searchForm()
                resolve(true)
              }
            })
          })
        case 'IdAddress':
          this.$root.$emit('bv::show::modal', 'bv-modal-address', '#btnShow')
          break
      }
      this.$refs.obsFieldsSearch.validate()
    },
    executeAddress: function () {
      return new Promise((resolve, reject) => {
        this.$refs.obsFieldsAddress.validate().then(results => {
          if (!results) {
            IberoHelpers.scrollToTop(0, 500)
            resolve(false)
          } else {
            debugger
            this.formUpdModel.IdAddress = this.dataObjFindJs(this.$store.state.listAddress, this.formAddModel.IdAddressList) + ' ' + this.formAddModel.IdAddressStreet + ' # ' + this.formAddModel.IdAddressNum + ' - ' + this.formAddModel.IdAddressRef
            if (this.formAddModel.IdAddressExtra !== '') {
              this.formUpdModel.IdAddress += ' | ' + this.formAddModel.IdAddressExtra
            }
            this.$root.$emit('bv::hide::modal', 'bv-modal-address', '#btnHide')
            resolve(true)
          }
        })
      })
    },
    dataObjFindJs: function (infoDaT, FinDaT) {
      return IberoHelpers.dataObjFind(infoDaT, FinDaT)
    },
    processData: function (dataInf, refdata) {
      this.limpiaref()
      IberoHelpers.getCitiesListByState(
        this.$store.state.ApiIbero.WSParametric,
        this.$store.state.CityList,
        dataInf.codResidenceDepartment
      )
      this.formUpdModel.IdStatus = dataInf.staStatus
      this.formUpdModel.IdUsrName = dataInf.usrName
      this.formUpdModel.IdPerson = dataInf.idPerson
      this.formUpdModel.IdDocType = dataInf.idDocumentType
      this.formUpdModel.IdDocTypeName = IberoHelpers.dataObjFind(
        this.$store.state.DocTypesList,
        dataInf.idDocumentType
      )
      this.formUpdModel.IdDocument = dataInf.numDocument
      this.formUpdModel.IdBanner = dataInf.idBanner
      this.formUpdModel.IdNombre = dataInf.namPerson
      this.formUpdModel.IdApellidos = dataInf.lastNamePerson
      this.formUpdModel.IdAddress = dataInf.resAddress

      this.formAddModel.IdAddressList = dataInf.ResAddressZone
      this.formAddModel.IdAddressStreet = dataInf.ResAddressStreet
      this.formAddModel.IdAddressNum = dataInf.ResAddressNumber
      this.formAddModel.IdAddressRef = dataInf.ResAddressReference
      this.formAddModel.IdAddressExtra = dataInf.ResAddressAditional

      this.formUpdModel.IdHomePhone = ''
      this.formUpdModel.IdCelPhone = ''
      this.formUpdModel.IdMail = ''

      if (!(dataInf.information === undefined)) {
        for (var i = 0; i < dataInf.information.length; i++) {
          if (dataInf.information[i].idContactType === 1) {
            this.formUpdModel.IdHomePhone =
              dataInf.information[i].desContactInformation
          } else if (dataInf.information[i].idContactType === 2) {
            this.formUpdModel.IdCelPhone =
              dataInf.information[i].desContactInformation
          } else if (dataInf.information[i].idContactType === 3) {
            this.formUpdModel.IdMail =
              dataInf.information[i].desContactInformation
          }
        }
      }

      this.formUpdModel.IdState = dataInf.codResidenceDepartment
      this.formUpdModel.IdCity = dataInf.codResidenceCity

      var res = dataInf.birthDate.split('-')
      if (res.length === 3) {
        var vDay = res[2]
        var vMonth = res[1]
        var vYear = res[0]
        this.formUpdModel.IdBornDay = vDay
        this.formUpdModel.IdBornMon = vMonth
        this.formUpdModel.IdBornYear = vYear
        this.formUpdModel.IdDateBirth = new Date(vYear + '/' + vMonth + '/' + vDay).toISOString()
      } else {
        this.formUpdModel.IdDateBirth = dataInf.birthDate.toISOString()
      }

      this.formUpdModel.IdObservaciones = ''

      this.formUpdModel.IdTermiCondi = dataInf.termsConditions
      this.formUpdModel.IdNewsLetter = dataInf.infReceive
      this.formUpdModel.CodTransferCenter = dataInf.transferCenterModels

      IberoHelpers.forceRerender2(this)
      this.$modal.show('UpdateModal')
    },
  },
}
</script>
